import React, { PropsWithChildren, useRef } from 'react';
import { Backdrop, Content, ModalHeader } from './index.styled';
import {
  useCloseOnBackdropClick,
  useCloseOnEscapeKeyDown,
} from './modalEventHandling';

export interface ModalProps extends PropsWithChildren {
  title?: string;
  open: boolean;
  onClose: () => void;
  disableEscapeKeyDown?: boolean;
  disableEscapeBackdropClick?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  children,
  title,
  open,
  onClose,
  disableEscapeKeyDown = false,
  disableEscapeBackdropClick = false,
  ...props
}) => {
  const backdropRef = useRef(null);

  useCloseOnEscapeKeyDown(onClose, disableEscapeKeyDown);
  useCloseOnBackdropClick(backdropRef, onClose, disableEscapeBackdropClick);

  // todo add portal
  return open ? (
    <Backdrop {...props}>
      <Content ref={backdropRef}>
        {title && <ModalHeader>{title}</ModalHeader>}
        {children}
      </Content>
    </Backdrop>
  ) : null;
};
